export const TableHelpers = {
    data() {
        return {
            tableColumns: [

                {
                    title: "Nombre del sitio virtual",
                    type: 'text',
                    key: 'name',
                },
                {
                    title: "Número de personal que está vinculado al sitio virtual",
                    type: 'text',
                    key: 'number_people_linked',
                },
                {
                    title: 'Actividades realizadas en el sitio virtual',
                    type: 'text',
                    key: 'activities',
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}